<template>
  <div id="app">
    <AGWAudio :file="music.file" :loop="music.loop" :autoplay="music.autoplay"/>
    <AGWHero overlay :background="backgrounds" ref="hero" parallax target="#intro"/>

    <div class="agw-content bg-white" :style="{ 'margin-top' : `${$root.hero.height}px` }">
      <AGWIntro id="intro"/>

      <div class="pad-y-60">
        <AGWPawiwahan id="pawiwahan"/>
        <AGWMepandes id="mepandes" class="mar-top-60" :mepandes="mepandes"/>
      </div>

      <AGWCounter
        id="counter"
        class="pad-y-60"
        :background="background"
        date="2020-03-30 14:00:00"
      />
      <AGWGallery id="gallery" class="pad-y-60"/>
      <AGWMap
        :height="450"
        url="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1971.8812863358332!2d115.5046939757921!3d-8.714081998427217!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zOMKwNDInNTAuNyJTIDExNcKwMzAnMjAuOSJF!5e0!3m2!1sen!2sid!4v1582776853159!5m2!1sen!2sid"
        directionUrl="https://www.google.com/maps/dir//-8.714082,115.505791/@-8.714082,115.504694,18z/data=!4m2!4m1!3e0?hl=en-ID"
        :location="location"
        :date="date"
        :time="time"
        id="map"
      />
    </div>

    <div class="agw-content" style="background: transparent">
      <attendance id="attendance" class="pad-y-60"></attendance>
    </div>

    <div :style="{ 'height' : `${$root.dividerHeight}px` }"></div>

    <section class="footer bg-white pad-y-20" ref="footer">
      <div class="font-weight-lighter">
        &copy; {{ $moment().format('YYYY') }}. Made by <a href="https://ceremonyku.com">ceremonyku</a>.
      </div>
    </section>

    <transition name="slide-fade">
      <guest-box :floating="true" v-if="$root.scroll.Y > $root.hero.height"/>
    </transition>

    <div class="snackbar" v-if="sw.updateExists">
      New version available!
      <button @click="refreshApp" class="btn">REFRESH</button>
    </div>
  </div>
</template>

<script>
const ImageHero1 = 'https://ik.imagekit.io/aryraditya/ceremonyku/widhi-arni/SAP_3345_0owpcx6rL.jpg'
const ImageHero2 = 'https://ik.imagekit.io/aryraditya/ceremonyku/widhi-arni/SAP_3594_wwPVL33fv.jpg'
const ImageHero3 = 'https://ik.imagekit.io/aryraditya/ceremonyku/widhi-arni/SAP_3661_aVNuteehT.jpg'
const ImageHero4 = 'https://ik.imagekit.io/aryraditya/ceremonyku/widhi-arni/SAT_2855_SjdImxFcp.jpg'

import Audio from "@/assets/audio/I Will Spend My Whole Life Loving You - Kina Grannis & Imaginary Future.mp3";

import AGWHero from "@/components/Hero";
import AGWIntro from "@/components/Intro";
import AGWPawiwahan from "@/components/Pawiwahan";
import AGWMepandes from "@/components/Mepandes";
import AGWCounter from "@/components/Counter";
import AGWGallery from "@/components/Gallery";
import AGWMap from "@/components/Maps";
import AGWAudio from "@/components/Audio";
import GuestBox from "@/components/GuestBox";
import Attendance from "@/components/Attendance";

import { setInterval } from "timers";

export default {
  name: "app",
  components: {
    AGWHero,
    AGWIntro,
    AGWPawiwahan,
    AGWMepandes,
    AGWCounter,
    AGWGallery,
    AGWMap,
    AGWAudio,
    GuestBox,
    Attendance
  },
  data() {
    return {
      title: 'Pawiwahan',
      backgrounds: [ImageHero4, ImageHero1, ImageHero2, ImageHero3],
      bgActive: 0,
      dividerHeight: 0,
      location: "Br. Cubang, Ds. Sakti, Kec. Nusa Penida, Klungkung - Bali",
      date: "Senin, 30 Maret 2020",
      time: {
        start: "14.00",
        end: "Selesai"
      },
      wedding: {
        man: {
          name: 'I Ketut Widiastra,S.H',
          surname: 'Widhi',
          address: 'Br. Cubang, Ds. Sakti, Kec. Nusa Penida, Klungkung, Bali',
          parents: 'I Ketut Wikan & Ni Wayan Gari',
          description: 'Putra keempat',
          photo: 'https://ik.imagekit.io/aryraditya/ceremonyku/widhi-arni/SAP_3378_JJ5VodinH.jpg?tr=w-300',
        },
        woman: {
          name: 'Ni Putu Arnivianti,S.E',
          surname: 'Arni',
          address: 'Br. Dinas Puspajati, Ds Gunungsari, Kec. Seririt - Buleleng, Bali',
          parents: 'I Wayan Ariawan & Ni Wayan Mariani',
          description: 'Putri pertama',
          photo: 'https://ik.imagekit.io/aryraditya/ceremonyku/widhi-arni/SAP_3312_wDCXHuF-tL.jpg?tr=w-300',
        },
      },
      mepandes: [
      ],
      music: {
        file: Audio,
        autoplay: true,
        loop: true
      },
      sw: {
        refreshing: false,
        registration: null,
        updateExists: false
      }
    };
  },
  computed: {
    background() {
      return this.backgrounds[this.bgActive];
    }
  },
  mounted() {
    this.dividerHeight = `calc(100vh - ${this.$refs.footer.offsetHeight}px)`;
    setInterval(() => {
      let active = this.bgActive + 1;
      if (active >= this.backgrounds.length) {
        active = 0;
      }

      this.bgActive = active;
    }, 5000);
  },
  created() {
    document.addEventListener("swUpdated", this.showRefreshUI, { once: true });
    if(navigator.serviceWorker) {
      navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (this.sw.refreshing) return;
      this.sw.refreshing = true;
      window.location.reload();
    });
    }
  },
  methods: {
    showRefreshUI(e) {
      this.sw.registration = e.detail;
      this.sw.updateExists = true;
    },
    refreshApp() {
      this.sw.updateExists = false;
      if (!this.sw.registration || !this.sw.registration.waiting) {
        return;
      }
      this.sw.registration.waiting.postMessage("skipWaiting");
    }
  }
};
</script>
